import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";
import { isEmpty } from "lodash";

const fetchProgramById = async (id) => {
  if (id) {
    return await axios.get(API_URL + `/api/Degree/GetDegreeById/${id}`, {
      headers: securityHeaders,
    });
  }
};

const fetchDegrees = async (pageSize, page, search) => {
  return await axios.get(
    API_URL +
      `/api/Degree/GetDegrees/${pageSize}/${page}${
        !isEmpty(search) ? "?SearchBy=" + search : ""
      }`,
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchProgramById = (id) => {
  return useQuery({
    queryKey: [`program-${id}`],
    queryFn: () => fetchProgramById(id),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchDegrees = (pageSize, page, search) => {
  return useQuery({
    queryKey: ["degreesPrograms"],
    queryFn: () => fetchDegrees(pageSize, page, search),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};

/********Delete Program */
const deleteProgram = (programId) => {
  return axios.post(
    API_URL + `/api/Degree/DeleteDegree?DegreeId=${programId}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useDeleteProgram = () => {
  return useMutation(deleteProgram);
};

/********Delete course */
const deleteCourse = (courseId) => {
  return axios.post(
    API_URL + `/api/Degree/RemoveCurriculumDetails/${courseId}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useDeleteCourse = () => {
  return useMutation(deleteCourse);
};
